import React, { useEffect, useState } from 'react'
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { formatAmount } from '../../utils/formatAmount';
import useReport from './useReport';

const MoneyExchangeSummaryReport = () => {

  const {reportData, getMoneyExchangeSummaryReport} = useReport() 

  useEffect(() => {
    getMoneyExchangeSummaryReport()
  },[])
  
  return (
    <TableContainer component={Paper}>
      <Table aria-label="collapsible table">
        <TableHead>
          <TableRow className='bg-indigo-600'>
            <TableCell style={{ color: 'white', fontWeight : 'bold'}} >Month</TableCell>
            <TableCell style={{ color: 'white', fontWeight : 'bold'}} >Total JPY</TableCell>
            <TableCell style={{ color: 'white', fontWeight : 'bold'}} >Total THB</TableCell>
            <TableCell style={{ color: 'white', fontWeight : 'bold'}} >Average Rate</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {reportData && reportData.map((row) => (
            <TableRow key={row.month}>
              <TableCell>{row.month}</TableCell>
              <TableCell>{formatAmount(row.totalJpy)}</TableCell>
              <TableCell>{formatAmount(row.totalThb)}</TableCell>
              <TableCell>{(row.totalThb / row.totalJpy).toFixed(4)}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default MoneyExchangeSummaryReport